import React from 'react';
import PlayerUpdateForm from '../../components/PlayerUpdateForm/PlayerUpdateForm';

export default function PlayerUpdate() {
    return <PlayerUpdateForm />;
}